// src/encounter/services/use-flag-categories.ts
// GET /api/Appointment/GetFlagList[?searchText=] → FlagCategoryGroup[] for the add-flag
// picker. Appointment service (reachability-verified 401, 2026-06-14). Categories are
// catalog data (not patient-specific); query gates on `enabled` so it only fires when the
// picker opens. Grounded: common_data_source_impl.dart:523-531.
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { GetFlagListResponse, FlagCategoryGroup } from '@/types/flags-api';

export function useFlagCategories(enabled: boolean, search = '') {
  const q = search.trim();
  return useQuery<FlagCategoryGroup[]>({
    queryKey: ['flag-categories', q],
    enabled,
    queryFn: async ({ signal }) => {
      const path = q
        ? `/api/Appointment/GetFlagList?searchText=${encodeURIComponent(q)}`
        : '/api/Appointment/GetFlagList';
      const res = await get<GetFlagListResponse>(path, { signal });
      return res ?? [];
    },
  });
}
